import { formatterRub, formatterRubWithCurrency } from '@/shared/utils/formatters'

interface BaseProgressBarProps {
  currentBalance: number
  totalBalance: number
  variant?: 'card' | 'table' | 'full' | 'big'
  textClasses?: string
}

export const BaseProgressBar = ({
  currentBalance,
  totalBalance,
  variant = 'card',
  textClasses = '',
}: BaseProgressBarProps) => {
  const containerClasses =
    variant === 'card'
      ? 'flex flex-col flex-wrap lg:flex-row lg:items-center gap-2 md:gap-[10px]'
      : variant === 'table'
        ? 'flex flex-col gap-2'
        : 'flex flex-col flex-wrap lg:flex-row lg:items-center gap-2 md:gap-[10px]'

  const isCard = variant === 'card'
  const fontClasses = isCard
    ? 'text-base'
    : variant === 'table'
      ? 'text-xs'
      : variant === 'big'
        ? 'text-[28px] font-medium'
        : 'text-sm md:text-base'
  const barClasses = isCard
    ? 'max-w-[178px] h-2'
    : variant === 'table'
      ? 'max-w-[150px] h-1'
      : variant === 'big'
        ? 'w-full h-1 md:h-[6px]'
        : 'w-full h-1 md:h-2'
  const percentage = currentBalance !== 0 ? (currentBalance / totalBalance) * 100 : 0

  return (
    <div className={`${containerClasses}`}>
      <div className={`font-medium ${fontClasses} ${textClasses}`}>
        <span>{formatterRub.format(currentBalance)}</span>
        <span className={isCard ? '' : 'text-text-secondary'}> / </span>
        <span className={isCard ? '' : 'text-text-secondary'}>
          {formatterRubWithCurrency.format(totalBalance)}
        </span>
      </div>
      <div className={`w-full bg-card-border rounded-full ${barClasses}`}>
        <div
          className={`h-full bg-primary dark:bg-primary-dark rounded-full`}
          style={{ width: `${percentage > 100 ? 100 : percentage}%` }}
        ></div>
      </div>
    </div>
  )
}
